var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZhFlag(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.77411,
    height: 55,
    viewBox: "0 0 45.77411 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#61b2e4;}.cls-2{fill:#fff;}.cls-2,.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ZH"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.77411,31.96629c0,12.20787-9.82584,22.03371-21.73596,22.03371C10.83029,54,1.3022,44.17416,1.3022,31.96629h0V1H44.77411V31.96629Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ZH-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.77411,31.96629c0,12.20787-9.82584,22.03371-21.73596,22.03371C10.83029,54,1.3022,44.17416,1.3022,31.96629h0V1H44.77411V31.96629Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.00669,1L40.00669,45.07c-3.87,5.65-10.42,8.93-17.27,8.93C10.53669,53.7,.70669,43.28,1.00669,30.78V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.73669,54c6.85,0,13.4-3.28,17.27-8.93L1.00669,1V30.78c-.3,12.5,9.53,22.92,21.73,23.22Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhFlag);
export default __webpack_public_path__ + "static/media/zh-flag.b68045a617bc792e81228d22700844e2.svg";
export { ForwardRef as ReactComponent };